module.exports = __webpack_public_path__ + "static/media/LGSmartLight__W.9d5a3951.eot";